import React, { memo, SVGProps } from 'react'

export const Report = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.69312 6.5376C9.29568 6.5376 8.97312 6.86016 8.97312 7.2576V19.3517C8.97312 19.7491 9.29568 20.0717 9.69312 20.0717C10.0906 20.0717 10.4131 19.7491 10.4131 19.3517V7.2576C10.4131 6.86016 10.0906 6.5376 9.69312 6.5376Z"
      fill="currentColor"
    />
    <path
      d="M14.3069 8.59584C13.9094 8.59584 13.5869 8.9184 13.5869 9.31584V19.3507C13.5869 19.7482 13.9094 20.0707 14.3069 20.0707C14.7043 20.0707 15.0269 19.7482 15.0269 19.3507V9.31584C15.0269 8.9184 14.7043 8.59584 14.3069 8.59584Z"
      fill="currentColor"
    />
    <path
      d="M5.0784 13.0867C4.68096 13.0867 4.3584 13.4093 4.3584 13.8067V19.3507C4.3584 19.7482 4.68096 20.0707 5.0784 20.0707C5.47584 20.0707 5.7984 19.7482 5.7984 19.3507V13.8067C5.7984 13.4093 5.47584 13.0867 5.0784 13.0867Z"
      fill="currentColor"
    />
    <path
      d="M18.9216 3.92928C18.5242 3.92928 18.2016 4.25184 18.2016 4.64928V19.3507C18.2016 19.7482 18.5242 20.0707 18.9216 20.0707C19.319 20.0707 19.6416 19.7482 19.6416 19.3507V4.64928C19.6416 4.25184 19.319 3.92928 18.9216 3.92928Z"
      fill="currentColor"
    />
  </svg>
))
